export const Anchor = {
    topLeft: {x: 0, y: 0},
    topCenter: {x: 0.5, y: 0},
    topRight: {x: 1, y: 0},
    middleLeft: {x: 0, y: 0.5},
    middleCenter: {x: 0.5, y: 0.5},
    middleRight: {x: 1, y: 0.5},
    bottomLeft: {x: 0, y: 1},
    bottomCenter: {x: 0.5, y: 1},
    bottomRight: {x: 1, y: 1},
};
